import { render, staticRenderFns } from "./BloggerCard.vue?vue&type=template&id=94680e64&"
import script from "./BloggerCard.vue?vue&type=script&lang=js&"
export * from "./BloggerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports